module.exports = __webpack_public_path__ + "static/img/partner21-hover.0f17483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/partner21-hover.png
// module id = UXTi
// module chunks = 0